import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=0bf9cb65&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=0bf9cb65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9cb65",
  null
  
)

export default component.exports